import { createFromIconfontCN } from '@ant-design/icons';
import { memo } from 'react';

const IconFont = createFromIconfontCN({
  scriptUrl: ['//at.alicdn.com/t/c/font_4519730_zfs4y0zkgl.js', '//at.alicdn.com/t/c/font_4722749_kv5dj8vdgyj.js'],
});

export default memo(IconFont);
